import React, { useContext, useEffect, useState } from 'react';
import requests from '../utils/requests.js';
import functions from '../utils/functions.js';
import { PersonContext } from '../providers/Person.jsx';
import LabeledInput from '../common/LabeledInput.jsx';
import StyledInput from '../common/StyledInput.jsx';
import AutocompleteAny from '../common/AutocompleteAny.jsx';
import updateOrder from '../utils/requests/updateOrder.js';
import Expanded from './orders/Expanded.jsx';
import { s } from '../Style.jsx';

const Reports = () => {

    const { auth, newNotifications, silentNotification } = useContext(PersonContext);

    const [reportType, setReportType] = useState("");
    const [reportDriver, setReportDriver] = useState({ name: "" });
    const [reportVendor, setReportVendor] = useState({ name: "" });
    const [reportFrom, setReportFrom] = useState(new Intl.DateTimeFormat('en-CA', { timeZone: "America/New_York", year: 'numeric', month: '2-digit', day: '2-digit', }).format(new Date()));
    const [reportTo, setReportTo] = useState("");

    const [drivers, setDrivers] = useState([]);
    useEffect(() => { requests.getDrivers(auth).then(drivers => setDrivers(drivers)) }, []);

    const [driverReports, setDriverReports] = useState([]);
    const [gettingDriverReports, setGettingDriverReports] = useState(true);
    const [selectedReport, setSelectedReport] = useState(null);

    const [orders, setOrders] = useState([]);
    const [gettingOrders, setGettingOrders] = useState(true);
    useEffect(() => {

        if (reportType == "Driver Reports" && reportDriver.name && reportFrom) {
            setGettingDriverReports(true);
            requests.getDriverReports(auth, {
                fromDate: reportFrom,
                toDate: reportTo || undefined,
            }, reportDriver.id).then(driverReports => {
                setDriverReports(driverReports);
                setGettingDriverReports(false);
            });

        } else {
            setDriverReports([]);
            setGettingDriverReports(false);
        }

    }, [orders]);


    useEffect(() => {
        setViewingOrder(false);
    }, [reportType, reportFrom, reportTo]);
    useEffect(() => {

        if (reportType == "Vendor Invoices" && reportFrom && reportVendor.name)
            requests.getDispatchOrders(auth, { completed: true, fromDate: reportFrom, toDate: reportTo || undefined }, setGettingOrders).then(orders => setOrders(orders));

        else if (reportType == "Daily Sales" && reportFrom)
            requests.getDispatchOrders(auth, { completed: true, fromDate: reportFrom, toDate: reportTo || undefined }, setGettingOrders).then(orders => setOrders(orders));

        else if (reportType == "Driver Reports" && reportDriver.name && reportFrom)
            requests.getDispatchOrders(auth, { completed: true, driverId: reportDriver.id }, setGettingOrders).then(orders => setOrders(orders));

        else if (reportType == "Delivery Count Report" && reportFrom)
            requests.getDispatchOrders(auth, { completed: true, fromDate: reportFrom, toDate: reportTo || undefined }, setGettingOrders).then(orders => setOrders(orders));

        else
            setOrders([]);

    }, [reportType, reportVendor, reportDriver, reportFrom, reportTo, newNotifications, silentNotification]);

    const resetOrders = () => {
        requests.getDispatchOrders(auth, { completed: true, fromDate: reportFrom, toDate: reportTo || undefined }, setGettingOrders).then(orders => setOrders(orders));
    };

    const [people, setPeople] = useState([]);
    useEffect(() => { requests.getPeople(auth).then(people => setPeople(people)) }, []);

    const [vendors, setVendors] = useState([]);
    useEffect(() => { requests.getVendors(auth).then(vendors => setVendors(vendors)) }, []);

    const [viewingOrder, setViewingOrder] = useState(false);
    useEffect(() => { if (viewingOrder && orders?.length) setViewingOrder(orders.find(o => o.id === viewingOrder.id)); }, [orders]);

    const vendorReportOrders = orders.filter(o => {
        if (reportVendor.id) {
            return o.vendorId == reportVendor.id;
        } else {
            return false;
        }
    })

    return <>

        <div style={{ ...s.mobileContainer, paddingBottom: 0 }}>

            <LabeledInput labelstyle={{ width: 100 }} inputstyle={{ width: 160 }} boxstyle={{ ...s.row, marginBottom: 10 }} label="Report Type" value={reportType} type="select" def={[
                "Daily Sales",
                "Driver Reports",
                "Vendor Invoices",
                "Delivery Count Report",
            ]} onChange={setReportType} />

            {reportType == "Vendor Invoices" && <div style={{ ...s.row, marginBottom: 10 }}>
                <label>Vendor</label>
                <AutocompleteAny type="vendor" options={vendors} selected={reportVendor.id} onChange={setReportVendor} />
            </div>}

            {reportType == "Vendor Invoices" && reportVendor.name && <div style={{ ...s.row, marginBottom: 10, justifyContent: "flex-end" }}>
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="From" type="date" value={reportFrom} onChange={setReportFrom} />
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="To" type="date" value={reportTo} onChange={setReportTo} />
            </div>}

            {reportType == "Daily Sales" && <div style={{ ...s.row, marginBottom: 10, justifyContent: "flex-end" }}>
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="From" type="date" value={reportFrom} onChange={setReportFrom} />
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="To" type="date" value={reportTo} onChange={setReportTo} />
            </div>}

            {reportType == "Delivery Count Report" && <div style={{ ...s.row, marginBottom: 10, justifyContent: "flex-end" }}>
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="From" type="date" value={reportFrom} onChange={setReportFrom} />
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="To" type="date" value={reportTo} onChange={setReportTo} />
            </div>}

            {reportType == "Driver Reports" && <div style={{ ...s.row, marginBottom: 10 }}>
                <label>Driver</label>
                <AutocompleteAny type="driver" options={drivers} selected={reportDriver.id} onChange={setReportDriver} />
            </div>}

            {reportType == "Driver Reports" && reportDriver.name && <div style={{ ...s.row, marginBottom: 10, justifyContent: "flex-end" }}>
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="From" type="date" value={reportFrom} onChange={setReportFrom} />
                <LabeledInput boxstyle={{ maxWidth: 300 }} labelstyle={{ marginRight: 10 }} inputstyle={{ minWidth: 120 }} label="To" type="date" value={reportTo} onChange={setReportTo} />
            </div>}

            {reportType == "Vendor Invoices" && reportVendor.name && reportFrom && <>
                <div style={{ ...s.row, marginBottom: 10 }}>
                    <div>
                        <h3 style={{ marginBottom: 4 }} >{reportVendor.name} Invoice</h3>
                        <span style={{ fontSize: 12 }}>from {reportFrom} to {reportTo}</span>
                    </div>
                </div>
            </>}

            {reportType == "Daily Sales" && reportFrom && <>
                <div style={{ ...s.row, marginBottom: 10 }}>
                    <div>
                        <h3 style={{ marginBottom: 4 }}>Daily Sales</h3>
                        <span style={{ fontSize: 12 }}>from {reportFrom} to {reportTo}</span>
                    </div>
                </div>
            </>}


            {reportType == "Delivery Count Report" && reportFrom && <>
                <div style={{ ...s.row, marginBottom: 10 }}>
                    <div>
                        <h3 style={{ marginBottom: 4 }}>Delivery Count Report</h3>
                        <span style={{ fontSize: 12 }}>from {reportFrom} to {reportTo}</span>
                    </div>
                </div>
            </>}

            {reportType == "Driver Reports" && reportDriver.name && reportFrom && <>
                <div style={{ marginBottom: 10 }}>
                    <h3>Driver Reports for {reportDriver.name}</h3>
                </div>

                <div style={{ ...s.mobileContainer, paddingBottom: 0 }}>
                    <div style={{ ...s.box, paddingBottom: 0 }}>
                        <table style={s.table}>
                            <tr style={s.th}>
                                <th style={{ ...s.tableCell }}>On-Account: </th>
                                <th style={{ ...s.tableCell }}>${functions.formatMoney(orders.filter(o => driverReports.map(r => r.id).includes(o.driverReportId) && !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                            </tr>
                            <tr style={s.th}>
                                <th style={{ ...s.tableCell }}>Cash: </th>
                                <th style={{ ...s.tableCell }}>${functions.formatMoney(orders.filter(o => driverReports.map(r => r.id).includes(o.driverReportId) && vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                            </tr>
                            <tr style={s.th}>
                                <th style={{ ...s.tableCell }}>Hourly Earnings: </th>
                                <th style={{ ...s.tableCell }}>${functions.formatMoney(driverReports.reduce((a, b) => a + (b.earnings || 0), 0))}</th>
                            </tr>
                        </table>
                    </div>
                </div>
            </>}



            {reportType == "Delivery Count Report" && reportFrom && <>
                <div style={{ ...s.box, paddingBottom: 0 }}>
                    <table style={s.table}>
                        {gettingOrders && <tr style={s.cell(1)}><i className="fas fa-spinner fa-spin"></i></tr>}
                        {!gettingOrders && vendors.map((vendor, o) => <tr key={vendor.id} style={s.cell(o)}>
                            <td style={{ ...s.tableCell }}>{vendor.name}</td>
                            <td style={{ ...s.tableCell }}>{orders.filter(o => o.vendorId == vendor.id).length}</td>
                        </tr>)}
                    </table>
                </div>
            </>}

            {reportType == "Vendor Invoices" && reportVendor.name && reportFrom && <>
                <div style={{ ...s.box, paddingBottom: 0 }}>
                    <table style={s.table}>
                        <tr style={s.th}>
                            <th style={{ ...s.tableCell }}>Total Delivery Fee: </th>
                            <th style={{ ...s.tableCell }}>${functions.formatMoney(vendorReportOrders.reduce((a, b) => a + ((b.deliveryFee || 0) + (b.deliveryFeeTax || 0)), 0))}</th>
                        </tr>
                        <tr style={s.th}>
                            <th style={{ ...s.tableCell }}>Total Comission: </th>
                            <th style={{ ...s.tableCell }}>${functions.formatMoney(vendorReportOrders.reduce((a, b) => a + ((b.subtotalFloated && b.subtotalTotal) || 0), 0))}</th>
                        </tr>
                    </table>
                </div>
            </>}

        </div>

        <div style={s.desktopScrollContainer}>
            <div style={s.desktopContainer}>

                {reportType == "Vendor Invoices" && reportVendor.name && reportFrom && <>
                    <div style={{ ...s.box, paddingBottom: 0 }}>
                        <table style={s.table}>
                            <tr style={s.th}>
                                <th style={{ ...s.tableCell, flex: .2 }}>Order #</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Date</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Delivery Fee</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Tax</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Float</th>
                                <th style={{ ...s.tableCell }}>Address</th>
                            </tr>
                            {gettingOrders && <tr style={s.cell(1)}><i className="fas fa-spinner fa-spin"></i></tr>}
                            {!gettingOrders && (!!viewingOrder ? [viewingOrder] : vendorReportOrders).map((order, o) => <tr key={order.id} style={s.cell(o)}>
                                <td style={{ ...s.tableCell, flex: .2 }}>{order.id}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{order.date}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.deliveryFee || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.deliveryFee || 0)}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.deliveryFeeTax || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.deliveryFeeTax || 0)}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.subtotalFloated && order.subtotalTotal || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney((order.subtotalFloated && order.subtotalTotal) || 0)}</td>
                                <td style={s.tableCell}>{order.address || ""}</td>
                            </tr>)}
                        </table>
                    </div>
                </>}





                {reportType == "Daily Sales" && reportFrom && <>
                    <div style={{ ...s.box, paddingBottom: 0 }}>
                        <table style={s.table}>
                            <tr style={s.th}>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>Cash Totals: </th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.stripeFee || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.deliveryFee || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.deliveryFeeTax || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.deliveryFee || 0) + (b.deliveryFeeTax || 0) - (b.comission || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.subtotalFloated && b.subtotalTotal) || 0), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}></th>
                            </tr>
                            <tr style={s.th}>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>On-Account Totals: </th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.stripeFee || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.deliveryFee || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.deliveryFeeTax || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.deliveryFee || 0) + (b.deliveryFeeTax || 0) - (b.comission || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5, fontWeight: "initial" }}>${functions.formatMoney(orders.filter(o => vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.subtotalFloated && b.subtotalTotal) || 0), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}></th>
                            </tr>
                            <tr style={s.th}>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Grand Totals: </th>
                                <th style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.reduce((a, b) => a + ((b.stripeFee || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.reduce((a, b) => a + ((b.deliveryFee || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.reduce((a, b) => a + ((b.deliveryFeeTax || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.reduce((a, b) => a + ((b.deliveryFee || 0) + (b.deliveryFeeTax || 0) - (b.comission || 0)), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.reduce((a, b) => a + ((b.subtotalFloated && b.subtotalTotal) || 0), 0))}</th>
                                <th style={{ ...s.tableCell, flex: .5 }}></th>
                            </tr>
                        </table>
                    </div>
                    <div style={{ ...s.box, paddingBottom: 0 }}>
                        <table style={s.table}>
                            <tr style={s.th}>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ ...s.tableCell, flex: .2 }}>#</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Date</th>
                                {/* <th style={{ ...s.tableCell, flex: 1 }}>Vendor</th> */}
                                {/* <th style={{ ...s.tableCell, flex: 1 }}>Address</th> */}
                                {/* <th style={{ ...s.tableCell, flex: .5 }}>Driver</th> */}
                                <th style={{ ...s.tableCell, flex: .5 }}>Stripe Fee</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Delivery Fee</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Tax</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Comission</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Company</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Float</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>On-Account</th>
                            </tr>
                            {gettingOrders && <tr style={s.cell(1)}><i className="fas fa-spinner fa-spin"></i></tr>}
                            {!gettingOrders && (!!viewingOrder ? [viewingOrder] : orders).map((order, o) => <tr key={order.id} style={s.cell(o)}>
                                <td style={{ flex: .2 }}><s.IconButton icon="fas fa-edit" does={() => setViewingOrder(order)} /></td>
                                <td style={{ ...s.tableCell, flex: .2 }}>{order.id}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{order.date}</td>
                                {/* <td style={s.tableCell}>{order.vendorName || order.pickup || ""}</td> */}
                                {/* <td style={s.tableCell}>{order.address || ""}</td> */}
                                {/* <td style={{ ...s.tableCell, flex: .5 }}>{drivers.find(d => d.id == order.driver)?.name || ""}</td> */}
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.stripeFee || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.stripeFee || 0)}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.deliveryFee || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.deliveryFee || 0)}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.deliveryFeeTax || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.deliveryFeeTax || 0)}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.comission || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.comission || 0)}</td>
                                <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney((order.deliveryFee || 0) + (order.deliveryFeeTax || 0) - (order.comission || 0)) == "0.00" ? 0 : 1 }}>${functions.formatMoney((order.deliveryFee || 0) + (order.deliveryFeeTax || 0) - (order.comission || 0))}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{order.subtotalFloated && <>${functions.formatMoney(order.subtotalTotal)}</>}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{vendors.find(v => v.id == order.vendorId)?.onaccount ? "Yes" : ""}</td>
                            </tr>)}
                        </table>
                    </div>
                </>}

                {reportType == "Driver Reports" && reportDriver.name && reportFrom && <>
                    <div style={s.box}>
                        <div style={s.table}>
                            <tr style={s.th}>
                                <th style={{ ...s.tableCell, flex: .2 }}></th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Report #</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Count</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Start Date</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Total comission</th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Earnings</th>
                            </tr>
                            {gettingDriverReports && <tr style={s.cell(1)}><i className="fas fa-spinner fa-spin"></i></tr>}
                            {!gettingDriverReports && driverReports.map((report, o) => <tr key={report.id} style={s.cell(o)}>
                                <td style={{ ...s.tableCell, flex: .2 }}><s.IconButton icon="fas fa-edit" does={() => setSelectedReport(report)} /></td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{report.id}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{orders.filter(o => o.driverReportId == report.id).length}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>{report.createdAt}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(orders.filter(o => o.driverReportId == report.id).reduce((a, b) => a + (b.comission || 0), 0))}</td>
                                <td style={{ ...s.tableCell, flex: .5 }}>${functions.formatMoney(report.earnings || 0)}</td>
                            </tr>)}
                        </div>
                    </div>
                </>
                }

                {
                    reportType == "Driver Reports" && reportDriver.name && reportFrom && selectedReport?.id && <>

                        <h3>Sales for Report #{selectedReport.id}</h3>

                        <div style={{ ...s.mobileContainer, paddingBottom: 0 }}>
                            <div style={{ ...s.box, paddingBottom: 0 }}>
                                <table style={s.table}>
                                    <tr style={s.th}>
                                        <th style={{ ...s.tableCell }}>On-Account: </th>
                                        <th style={{ ...s.tableCell }}>${functions.formatMoney(orders.filter(o => o.driverReportId == selectedReport.id && vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                                    </tr>
                                    <tr style={s.th}>
                                        <th style={{ ...s.tableCell }}>Cash: </th>
                                        <th style={{ ...s.tableCell }}>${functions.formatMoney(orders.filter(o => o.driverReportId == selectedReport.id && !vendors.find(v => v.id == o.vendorId)?.onaccount).reduce((a, b) => a + ((b.comission || 0)), 0))}</th>
                                    </tr>
                                    <tr style={s.th}>
                                        <th style={{ ...s.tableCell }}>Hourly Earnings: </th>
                                        <th style={{ ...s.tableCell }}>${functions.formatMoney(selectedReport.earnings || 0)}</th>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div style={{ ...s.box, paddingBottom: 0 }}>
                            <table style={s.table}>
                                <tr style={s.th}>
                                    <th style={{ ...s.tableCell, flex: .2 }}>Order #</th>
                                    <th style={{ ...s.tableCell, flex: .5 }}>Date</th>
                                    <th style={{ ...s.tableCell }}>Vendor</th>
                                    <th style={{ ...s.tableCell }}>Address</th>
                                    <th style={{ ...s.tableCell, flex: .5 }}>Delivery Fee</th>
                                    <th style={{ ...s.tableCell, flex: .5 }}>Tax</th>
                                    <th style={{ ...s.tableCell, flex: .5 }}>Comission</th>
                                    <th style={{ ...s.tableCell, flex: .5 }}>On-Account</th>
                                </tr>
                                {gettingOrders && <tr style={s.cell(1)}><i className="fas fa-spinner fa-spin"></i></tr>}
                                {!gettingOrders && (!!viewingOrder ? [viewingOrder] : orders)
                                    .filter(o => o.driverReportId == selectedReport.id)
                                    .map((order, o) => <tr key={order.id} style={s.cell(o)}>
                                        <td style={{ ...s.tableCell, flex: .2 }}>{order.id}</td>
                                        <td style={{ ...s.tableCell, flex: .5 }}>{order.date}</td>
                                        <td style={s.tableCell}>{order.pickup || order.vendorName || ""}</td>
                                        <td style={s.tableCell}>{order.address || ""}</td>
                                        <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.deliveryFee || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.deliveryFee || 0)}</td>
                                        <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.deliveryFeeTax || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.deliveryFeeTax || 0)}</td>
                                        <td style={{ ...s.tableCell, flex: .5, opacity: functions.formatMoney(order.comission || 0) == "0.00" ? 0 : 1 }}>${functions.formatMoney(order.comission || 0)}</td>
                                        <td style={{ ...s.tableCell, flex: .5 }}>{vendors.find(v => v.id == order.vendorId)?.onaccount ? "Yes" : ""}</td>
                                    </tr>)}
                            </table>
                        </div>
                    </>
                }

            </div>
        </div>
        <div style={{ ...s.mobileContainer }}>
            {
                reportType == "Daily Sales" && viewingOrder && <Expanded
                    deleteOrder={() => requests.deleteOrder(auth, viewingOrder.id, () => requests.getDispatchOrders(auth, {}, setGettingOrders).then(orders => setOrders(orders)))}
                    setOrders={setOrders}
                    setViewingOrder={setViewingOrder}
                    order={viewingOrder}
                    vendors={vendors}
                    drivers={drivers}
                    people={people}
                    orders={orders}
                    resetOrders={resetOrders}
                />
            }
        </div>
    </>;

}

export default Reports;
